import Vue from 'vue'
import {
  Notify,
  Toast,
  ImagePreview,
  // 引入组件
  ActionSheet,
  Button,
  Col,
  Dialog,
  DatetimePicker,
  Icon,
  Image,
  List,
  Loading,
  Overlay,
  Popup,
  Row,
  Tab,
  Tabs
} from 'vant'

export default (() => {
  /** 注册组件 */
  const COMPONENTS = [
    ActionSheet,
    Button,
    Col,
    Dialog,
    DatetimePicker,
    Icon,
    Image,
    List,
    Loading,
    Overlay,
    Popup,
    Row,
    Tab,
    Tabs,
    Toast
  ]
  for (const name of COMPONENTS) {
    Vue.use(name)
  }

  function success(message) {
    Notify({
      type: 'success',
      message
    })
  }

  function error(message) {
    Notify({
      type: 'danger',
      message
    })
  }

  function warning(message) {
    Notify({
      type: 'warning',
      message
    })
  }

  function loading(message) {
    Toast.loading({
      message: message,
      forbidClick: true
    })
  }

  function clearLoading() {
    Toast.clear()
  }

  const notify = {
    success,
    error,
    warning
  }

  Vue.prototype.$notify = notify
  Vue.prototype.$toast = Toast
  Vue.prototype.$loading = loading
  Vue.prototype.$clearLoading = clearLoading
  global.$notify = Notify
  Vue.prototype.ImagePreview = ImagePreview
})()
